import { DateFilter } from "@cartographerio/atlas-map";
import { timestampEpoch } from "@cartographerio/types";
import { expr, MapboxExpr } from "../mapbox";

export function createDateFilter({ from, to }: DateFilter): MapboxExpr {
  return expr.any(
    expr.not(expr.has("timestamp")),
    expr.all(
      from ? expr.gte(expr.get("timestamp"), timestampEpoch(from)) : true,
      to ? expr.lte(expr.get("timestamp"), timestampEpoch(to)) : true
    )
  );
}
